import { QRCodeSVG } from "qrcode.react";
import { T } from "../data/content";
import { useLang } from "../context/LangContext";
import { useSiteData } from "../context/SiteDataContext";

export const BookingQR = ({ compact = false }) => {
  const { tr } = useLang();
  const { brand } = useSiteData();
  const waLink = `https://wa.me/${brand.whatsapp}`;

  return (
    <div className={`flex items-center gap-4 ${compact ? "" : "flex-col text-center sm:flex-row sm:text-left"}`} data-testid="booking-qr">
      <div className="rounded-lg bg-[#F5ECDA] p-2.5 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6)]">
        <QRCodeSVG
          value={waLink}
          size={compact ? 84 : 116}
          bgColor="#F5ECDA"
          fgColor="#0C0806"
          level="M"
        />
      </div>
      {!compact && (
        <div>
          <p className="font-serif text-lg text-[#F5ECDA]">{tr(T.qr.title)}</p>
          <p className="mt-1 max-w-[200px] text-xs leading-relaxed text-[#B7A78C]">{tr(T.qr.sub)}</p>
        </div>
      )}
    </div>
  );
};
